// 🔀 FUSÃO DE RANKINGS (RRF) — busca densa (Pinecone) + busca por palavras (BM25)
// Sistema: HEPATO TX RONDÔNIA
// AI_19: retrieval híbrido. B357 (AI_156): o BM25 saiu do navegador (era o
// bm25Search.ts, que baixava public/bm25-index.json de 20 MB) e passou a rodar
// no servidor (api/_lib/bm25Servidor.js, via buscarChunksHibridos). Aqui fica
// só a fusão, pura.

import { SearchResult } from "../types";

/**
 * Reciprocal Rank Fusion (RRF)
 * Combina rankings de múltiplos sistemas de retrieval.
 * Fórmula: score_RRF(d) = Σ 1/(k + rank(d))
 * k=60 é o valor padrão da literatura.
 */
export function reciprocalRankFusion(
  denseResults: SearchResult[],
  sparseResults: SearchResult[],
  k: number = 60
): SearchResult[] {
  const scores = new Map<string, { score: number; result: SearchResult }>();

  // Pontuação RRF para resultados densos (Pinecone)
  denseResults.forEach((result, rank) => {
    const id = result.chunk.id;
    const rrfScore = 1 / (k + rank + 1);
    scores.set(id, { score: rrfScore, result });
  });

  // Pontuação RRF para resultados esparsos (BM25)
  sparseResults.forEach((result, rank) => {
    const id = result.chunk.id;
    const rrfScore = 1 / (k + rank + 1);
    const existing = scores.get(id);

    if (existing) {
      // Documento aparece nos dois — soma os scores
      existing.score += rrfScore;
    } else {
      scores.set(id, { score: rrfScore, result });
    }
  });

  // Ordenar por score RRF combinado (decrescente)
  return Array.from(scores.values())
    .sort((a, b) => b.score - a.score)
    .map((entry) => ({
      ...entry.result,
      score: entry.score, // Score RRF substitui o score original
    }));
}
